var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptop2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2H3C2.448 2 2 2.447 2 3V12C2 12.553 2.448 13 3 13H21C21.552 13 22 12.553 22 12V3C22 2.447 21.552 2 21 2Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.632 19.734L21.948 14.683C21.809 14.265 21.418 14.012 20.999 14.011V14H2.99998V14.012C2.58098 14.013 2.19098 14.266 2.05098 14.684L0.366976 19.736C0.180976 20.294 0.256976 20.866 0.574976 21.307C0.893976 21.747 1.41298 22 1.99998 22H22C22.587 22 23.106 21.747 23.424 21.307C23.742 20.865 23.818 20.293 23.632 19.734ZM14 19H9.99998V17H14V19Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptop2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop-2.39e34b876f8c0cbb0c2204ba727d935f.svg";